import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ReactComponent as Warning } from '../../../../../assets/icons/modal/warning.svg';
import { useCommonBoundStore } from '../../../../../common/stores/useStore';
import { useCaseChanges, useModalSaveChanges } from '../../../../../hooks';
import { useOrthBoundStore } from '../../../../../orthodontics/stores/useStore';

type ModalNextStepTypes = {
  nextRoute?: string;
};

export function ModalNextStepDirect({ nextRoute }: ModalNextStepTypes) {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { toggleModalIsOpened, updateRouteToGo } = useCommonBoundStore();
  const { currentVersion } = useOrthBoundStore();
  const { isCaseModified, onChangeRoute } = useCaseChanges();
  const { getPhaseSaveChange } = useModalSaveChanges();
  const { saveChanges } = getPhaseSaveChange();

  const onCloseButtonClick = () => {
    toggleModalIsOpened('');
  };

  const onContinueButtonClick = useCallback(async () => {
    if (currentVersion === null) {
      return;
    }

    if (isCaseModified) {
      updateRouteToGo(nextRoute);
      onChangeRoute();
      return;
    }

    const result = await saveChanges();
    if (!result) {
      return;
    }

    navigate(nextRoute);
    toggleModalIsOpened('');
  }, [nextRoute, onChangeRoute, isCaseModified, currentVersion]);

  return (
    <div className="modal-content" data-testid={'modal-nextStep'}>
      <div className="modal-body d-flex flex-column align-items-center">
        <Warning className="modal-icon mb-3" />
        <h3 className="modal-title mb-4">{t(`modal.nextStepDirect.title`)}</h3>
        <p className="modal-text text-center mb-0">{t(`modal.nextStepDirect.description`)}</p>
      </div>

      <div className="modal-footer d-flex flex-grow-1">
        <button
          onClick={onCloseButtonClick}
          type="button"
          className="btn btn-outline-primary flex-fill modal-button"
          data-bs-dismiss="modal"
        >
          {t(`modal.actions.close`)}
        </button>
        <button onClick={onContinueButtonClick} type="button" className="btn btn-primary flex-fill modal-button">
          {t(`modal.actions.continue`)}
        </button>
      </div>
    </div>
  );
}
